import React, { useState, useEffect, useRef } from 'react'
import cookie from 'react-cookies'
// import logo from '../../assets/logo.png'
import qrCode from '../../assets/qr_code.png';
import cloudscape from '../../assets/ai-cloudscape.png'
import magkeyLogo from '../../assets/magkey-logo.png'
import NormalLoginForm from '../../components/NormalLoginForm'
import CodeLogin from '../../components/CodeLogin'
import CodeLoginFs from '../../components/CodeLoginFs'
import './index.scss'
import {Button, message, Spin, Tabs, Tooltip} from 'antd'
import {getQueryString, messageTips} from '../../utils/index';
import {
    apiGetCaptcha,
    apiLogin,
    apiGetIPV4,
    apiGetIP,
    apiPhoneLogin,
    apiGetIDasImageCode,
    apiSSOLogin, apiSendSecondValidateCode
} from '../../request/api';
import {useForm} from "antd/es/form/Form";
import MobileLoginForm from "../../components/MobileLoginForm";
import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'
// import insert_img  from '../../assets/insert.png'
const { TabPane } = Tabs;
const Login = (props) => {
    const [loginFormShow, setLoginFormShow] = useState(true)
    const [captcha, setCaptcha] = useState('')
    const [captchaImg, setCaptchaImg] = useState('')
    const [captchaShow, setCaptchaShow] = useState(false);
    const [secondValidateShow,setSecondValidateShow] = useState(false);
    const [mobileSecondValidateShow,setMobileSecondValidateShow] = useState(false);
    // const [secondValidateDisabled,setSecondValidateDisabled] = useState(false);
    // const [secondValidateButtonText,setSecondValidateButtonText] = useState("获取二次验证码")
    const [secondValidateId,setSecondValidateId] = useState("");
    const [IDasImageShow,setIDasImageShow] = useState(false);
    const [mobileIDasImageShow,setMobileIDasImageShow] = useState(false);
    const [IDasImage,setIDasImage] = useState("");
    const [IDasImageCode,setIDasImageCode] = useState("");
    const [redirectUrl, setRedirectUrl] = useState(getQueryString("redirect"))
    const [appid,setAppid] = useState(getQueryString("appid"));
    const [requestId] = useState(getQueryString("requestCid"));
    const [isReturnSubordinate] = useState(getQueryString("isReturnSubordinate"));
    const [iPV4, setIPV4] = useState('39.100.68.27')
    const [accountForm] = useForm();
    const [mobileForm] = useForm();
    const loginFormCacheRef = useRef({
        password: {},
        sms: {}
    });
    const [loginType,setLoginType] = useState("password");
    const [scanLoginType,setScanLoginType] = useState("dingtalk");
    // const [form,setForm] = useState(accountForm);
    const [disabledSubmitButton,setDisabledSubmitButton] = useState(false);
    const [networkIP,setNetworkIP] = useState("39.100.68.27");
    const [refreshFidParams,setRefreshFidParams] = useState({})
    const [loadingText,setLoadingText] = useState("登录中...");
    // const capRef = useRef()
    
    // 二维码登录
    const showCodeLogin = () => {
        loginFormCacheRef.current = {
            password: accountForm.getFieldsValue(true),
            sms: mobileForm.getFieldsValue(true)
        };
        setLoginFormShow(false)
    }


    // 手机号登录
    const hideCodeLogin = () => {
        setLoginFormShow(true)
    }

    useEffect(() => {
        if (!loginFormShow) {
            return;
        }
        const { password, sms } = loginFormCacheRef.current;
        if (password && Object.keys(password).length) {
            accountForm.setFieldsValue(password);
        }
        if (sms && Object.keys(sms).length) {
            mobileForm.setFieldsValue(sms);
        }
    }, [loginFormShow, accountForm, mobileForm]);

    const loginSubmit = () => {
        setDisabledSubmitButton(true);
        accountForm.validateFields().then(values=> {
            
            let  params = {
                networkIP:networkIP,
                clientIp: iPV4,
                appId: appid,
                redirectUrl: redirectUrl,
                isReturnSubordinate:isReturnSubordinate,
                requestCid:requestId,
                ati:cookie.load("_ati"),
                eid:cookie.load("_eid"),
                ...values,
                f_Password:Base64.stringify(Utf8.parse(values.f_Password))
            }
            console.log(params,'..........params............')
            apiLogin(params).then(res => {
                if(!res.data.IsSuccess){
                    if(res.data.data&&res.data.data.LoginErrorCount){
                        const loginErrorCount = res.data.data.LoginErrorCount
                        if( loginErrorCount && loginErrorCount > 3){
                            getCaptcha()
                            setCaptchaShow(true)
                        }
                        localStorage.setItem('loginErrorCount', loginErrorCount)
                    }
                    messageTips(res.data.msg,'error');
                    setDisabledSubmitButton(false);
                } else {
                    // message.error(res.data.msg)
                    localStorage.removeItem('loginErrorCount')
                    if(redirectUrl != null){
                        window.location.href = `${redirectUrl}?token=${res.data.data.Token}`
                    }else{
                        setDisabledSubmitButton(false);
                        console.log("redirect url is null , do not for direct")
                    }

                }
            }).catch(err => {
                console.log(err)
            })
        })
    }
    const ssoLogin = () => {
        let submitForm = null;
        if(loginType === "password") {
          submitForm = accountForm;
        }else if(loginType === "sms") {
            submitForm = mobileForm;
        }
        if(submitForm) {
            submitForm.validateFields().then(params=> {
                setDisabledSubmitButton(true);
                let data = {
                    ...params,
                    LoginType:loginType,
                    ClientIp: networkIP,
                    AppId: appid,
                    RedirectUrl: redirectUrl,
                    RequestCid:requestId,
                    IsReturnSubordinate:isReturnSubordinate,
                    Ati:cookie.load("_ati"),
                    Eid:cookie.load("_eid"),
                    ImgCodeId:IDasImageCode,
                    Password : Base64.stringify(Utf8.parse(params.Password))
                }
                apiSSOLogin(data).then(res=> {
                    GetIDasImageCaptcha();
                    if(res.data.IsSuccess) {
                        setDisabledSubmitButton(false);
                        if(res.data.data) {
                            if(res.data.data.IsNeedImgCode) {
                                loginType ==="sms" ?setMobileIDasImageShow(true): setIDasImageShow(true);
                                messageTips('需要进行图片验证','error');
                                return;
                            } else if( res.data.data.IsNeedSecondFactor) {
                                loginType === "sms" ? setMobileSecondValidateShow(true):setSecondValidateShow(true);
                                setSecondValidateId(res.data.data.Fid);
                                setRefreshFidParams(data);
                                loginType === "sms" ? setMobileIDasImageShow(false):setIDasImageShow(false);
                                messageTips('需要进行二次验证','error');
                                return;
                            }else if(res.data.data.IsUpdatePassword){
                                props.history.push(`/Password?redirect=${redirectUrl}&appid=${appid}&requestCid=${requestId}`);
                                return;
                            }else {
                                setDisabledSubmitButton(false);
                                if(redirectUrl != null){
                                    window.location.href = `${redirectUrl}?token=${res.data.data.Token}`
                                }else{
                                    // console.log("redirect url is null , do not for direct")
                                    messageTips('redirect url is null', 'error')
                                }
                            }
                        }
                    }else {
                        setDisabledSubmitButton(false);
                        messageTips(res.data.msg,'error');
                    }
                })

            });
        }

    }
    // 获取验证码
    const getCaptcha = () => {
        apiGetCaptcha().then(res => {
            // console.log(res)
            if(res.data.IsSuccess){
                setCaptchaImg(res.data.data.Base64Stream)
                setCaptcha(res.data.data.Code)
            } else {
                messageTips(res.data.msg,'error')
            }
        }).catch(err => {
            console.log(err)
        })
    }
    const GetIDasImageCaptcha = () => {
       apiGetIDasImageCode().then(res => {
           if(res.data.IsSuccess){
               setIDasImage("data:image/png;base64,"+res.data.data.captcha)
               setIDasImageCode(res.data.data.code);
               if(loginType === "password") {
                   accountForm.resetFields(["ImgCode"])
               }else if(loginType === "sms") {
                   mobileForm.resetFields(["ImgCode"])
               }
           } else {
               messageTips(res.data.msg,'error')
           }
       }).catch(err => {
           console.log(err)
       })
    }
    // // 获取IPV4
    const getIPV4 = () => {
        apiGetIPV4().then(res => {
            if(res.data.IsSuccess){
                if(res.data.data !== '' && res.data.data != null){
                    setIPV4(res.data.data)
                }
            } else {
                message.error(res.data.msg)
            }
        }).catch(err => {
            console.log(err)
        })
    }
    //获取网络ip
    const getIP = () => {
        apiGetIP().then(res => {
            if(res.data.IsSuccess){
                if(res.data.data !== '' && res.data.data != null){
                    setNetworkIP(res.data.data)
                }
            } else {
               messageTips(res.data.msg,'error')
            }
        }).catch(err => {
            console.log(err)
        })
    }


    // 检查输错次数
    const checkErrorCount = () => {
        const localErrorCount = localStorage.getItem('loginErrorCount')
        // console.log(localErrorCount)
        if(localErrorCount > 3){
            setCaptchaShow(true)
        }
    }

    // 验证码切换
    const handleClick = () => {
        getCaptcha()
    }
    const MobileLoginSubmit = () => {
        mobileForm.validateFields().then(values=> {
            if(captchaShow && captcha !== values.imageCode) {
                messageTips("图片验证码错误",'error');
                return;
            }
            let  params = {
                NetworkIP:networkIP,
                ClientIp: iPV4,
                AppId: appid,
                RedirectUrl: redirectUrl,
                RequestCid:requestId,
                IsReturnSubordinate:isReturnSubordinate,
                Ati:cookie.load("_ati"),
                Eid:cookie.load("_eid"),
                Phone:values.phoneNumber,
                LoginPhoneCode:values.validateCode,
                LoginPhoneCodeId:values.codeId,
            }
            setDisabledSubmitButton(true);
            apiPhoneLogin(params).then(res=> {
                console.log(res,'........phone login result')
                if(!res.data.IsSuccess){
                    if(res.data.data&&res.data.data.LoginErrorCount){
                        const loginErrorCount = res.data.data.LoginErrorCount
                        if( loginErrorCount && loginErrorCount > 3){
                            getCaptcha()
                            setCaptchaShow(true)
                        }
                        localStorage.setItem('loginErrorCount', loginErrorCount)
                    }
                    messageTips(res.data.msg,'error');
                    setDisabledSubmitButton(false);
                } else {
                    // message.error(res.data.msg)
                    localStorage.removeItem('loginErrorCount')
                    if(redirectUrl != null){
                        window.location.href = `${redirectUrl}?token=${res.data.data.Token}`
                    }else{
                        setDisabledSubmitButton(false);
                        console.log("redirect url is null , do not for direct")
                    }

                }
            }).catch(err=> {
                console.log(err)
                setDisabledSubmitButton(false);
            })
        })
    }
    useEffect(() => {
        message.config({
            getContainer: () => document.querySelector('.login_content_box') || document.body,
            top: 64
        })
        checkErrorCount()
       // getCaptcha()
        GetIDasImageCaptcha();
        getIP();
        getIPV4()
        const errorMessage = getQueryString('errorMessage')
        const token = getQueryString('token')
        const redirectUrl = getQueryString('redirect')
        // console.log(redirectUrl)
        localStorage.setItem('redirectUrl', redirectUrl)
        setRedirectUrl(redirectUrl)
        if( errorMessage && errorMessage !== ''){
            message.error(errorMessage)
        }
        if( token && token !== ''){
            props.history.push(`/Demo?token=${token}`)
        }
        // eslint-disable-next-line
    }, [])

    const handleHeroPointerMove = (event) => {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const x = (event.clientX / window.innerWidth - 0.5) * -18;
        const y = (event.clientY / window.innerHeight - 0.5) * -12;
        event.currentTarget.style.setProperty('--mx', `${x}px`);
        event.currentTarget.style.setProperty('--my', `${y}px`);
    }

    return (
        <div className='page_box' onPointerMove={handleHeroPointerMove}>
            <header className='ai-topbar'>
                <div className='ai-brand'>
                    <img src={magkeyLogo} alt='MAGKEY' />
                    <span>麦格凯科技</span>
                </div>
                {/*<nav className='ai-nav' aria-label='登录页导航'>
                    <span>身份中台</span>
                    <span>安全认证</span>
                    <span>智能办公入口</span>
                </nav>
                <div className='ai-top-actions'>
                    <span className='ai-status'>服务在线</span>
                    <span>帮助中心</span>
                </div>*/}
            </header>
            <img className='ai-hero-media' src={cloudscape} alt='' aria-hidden='true' />
            <div className='ai-hero-tint' />
            <div className='ai-particle-field' />
            <div className='ai-hero-inner'>
            <section className='ai-hero-copy' aria-label='统一身份登录介绍'>
                <div className='ai-eyebrow'><i /> 安全链接保持</div>
                <h1>一个入口，<br></br>连接所有工作。</h1>
                <p>统一身份、安全访问、智能协同。登录后即可进入麦格凯企业应用与数据服务。</p>
            </section>
            <div className='login_box'>
                {/*<div className='header_box'>
                    <img src={logo}  alt="" />
                </div>*/}
                <div className='login_content_box'>

                    <div className='login_right'>

                        {
                            loginFormShow? (
                                <div>
                                    <div className="body-header">
                                        <div className="login-heading">
                                            <div className="welcome">欢迎回来</div>
                                            <div className="login-subtitle">使用企业账号进入智能工作空间</div>
                                        </div>
                                        <div className="qr-secure-badge" style={{padding:"8px"}} onClick={showCodeLogin}>
                                                <Tooltip overlayInnerStyle={{height:8,fontSize:10,color:"#1BB4C2"}}
                                                         placement="left" trigger="hover"
                                                         color="#FFFFFF" title="扫码登录更方便">
                                                    <img src={qrCode} width="32px"  alt="" />
                                                </Tooltip>
                                        </div>
                                    </div>
                                    <div className="body-form">
                                        <div className={disabledSubmitButton ? "login-spin-mask show" : "login-spin-mask"}>
                                            <Spin size="default" spinning={disabledSubmitButton} tip={loadingText}></Spin>
                                        </div>
                                        <Tabs activeKey={loginType} onChange={(key)=>{setLoginType(key)}}>
                                            <TabPane tab="账号登录" key="password">
                                                        <NormalLoginForm
                                                                         form={accountForm}
                                                                         disabled={disabledSubmitButton}
                                                                         handleClick={handleClick}
                                                                         captcha={captcha}
                                                                         captchaImg={captchaImg}
                                                                         captchaShow={captchaShow}
                                                                         secondValidateShow={secondValidateShow}
                                                                         secondValidateId={secondValidateId}
                                                                         IDasImageShow={IDasImageShow}
                                                                         setIDasImageShow={setIDasImageShow}
                                                                         IDasImage={IDasImage}
                                                                         IDasImageCode={IDasImageCode}
                                                                         IDasImageClick={GetIDasImageCaptcha}
                                                                         redirectUrl={redirectUrl}
                                                                         appid={appid}
                                                                         requestId={requestId}
                                                                         refreshFidData={refreshFidParams}
                                                                         setLoginButtonDisabled={setDisabledSubmitButton}
                                                                         setLoadingText={setLoadingText}
                                                        />
                                            </TabPane>
                                            <TabPane tab="手机号登录" key="sms">
                                                        <MobileLoginForm
                                                                         form={mobileForm}
                                                                         captchaShow={captchaShow}
                                                                         captcha={captcha}
                                                                         captchaImg={captchaImg}
                                                                         IDasImageShow={mobileIDasImageShow}
                                                                         setIDasImageShow={setMobileIDasImageShow}
                                                                         IDasImage={IDasImage}
                                                                         IDasImageCode={IDasImageCode}
                                                                         IDasImageClick={GetIDasImageCaptcha}
                                                                         secondValidateShow={mobileSecondValidateShow}
                                                                         secondValidateId={secondValidateId}
                                                                         refreshFidData={refreshFidParams}
                                                                         setLoginButtonDisabled={setDisabledSubmitButton}
                                                                         setLoadingText={setLoadingText}
                                                        />
                                            </TabPane>
                                        </Tabs>
                                    </div>
                                    {/*<Tabs defaultActiveKey="1">*/}
                                    {/*    <TabPane tab="账户密码登录" key="1">*/}
                                    {/*        <NormalLoginForm onFinish={ssoLogin}*/}
                                    {/*                         form={form}*/}
                                    {/*                         disabled={disabledSubmitButton}*/}
                                    {/*                         handleClick={handleClick}*/}
                                    {/*                         captcha={captcha}*/}
                                    {/*                         captchaImg={captchaImg}*/}
                                    {/*                         captchaShow={captchaShow}*/}
                                    {/*                         secondValidateShow={secondValidateShow}*/}
                                    {/*                         secondValidateClick={sendSecondValidateCode}*/}
                                    {/*                         secondValidateDisabled={secondValidateDisabled}*/}
                                    {/*                         secondValidateId={secondValidateId}*/}
                                    {/*                         IDasImageShow={IDasImageShow}*/}
                                    {/*                         IDasImage={IDasImage}*/}
                                    {/*                         IDasImageCode={IDasImageCode}*/}
                                    {/*                         IDasImageClick={GetIDasImageCaptcha}*/}
                                    {/*                         redirectUrl={redirectUrl}*/}
                                    {/*                         appid={appid}*/}
                                    {/*                         requestId={requestId}*/}
                                    {/*        />*/}

                                    {/*    </TabPane>*/}
                                    {/*    <TabPane tab="手机号登录" key="2">*/}
                                    {/*        <MobileLoginForm onFinish={MobileLoginSubmit}*/}
                                    {/*                         form={mobileForm}*/}
                                    {/*                         captchaShow={captchaShow}*/}
                                    {/*                         secondValidateShow={secondValidateShow}*/}
                                    {/*                         captcha={captcha}*/}
                                    {/*                         captchaImg={captchaImg}*/}
                                    {/*        />*/}
                                    {/*    </TabPane>*/}
                                    {/*</Tabs>*/}
                                    {/*<div className='code_box1' onClick={showCodeLogin}>*/}
                                    {/*    <Tooltip overlayInnerStyle={{height:10,fontSize:12}}*/}
                                    {/*             placement="left" trigger="hover"*/}
                                    {/*             color="#1BB4C2" title="扫码登录更方便">*/}
                                    {/*        <img src={qrCode}  alt="" />*/}
                                    {/*    </Tooltip>*/}

                                    {/*</div>*/}
                                    {/*<div style={{position:"absolute",top:240,left:150,fontSize:12}}>*/}
                                    {/*    <Spin style={{fontSize:12}} spinning={disabledSubmitButton} tip="登录中...."/>*/}
                                    {/*</div>*/}

                                    <div className="login-actions">
                                        <div className="login-submit-row" style={{position:'absolute',bottom:20,left:20}}>
                                            <Button className="login_btn" disabled={disabledSubmitButton} onClick={ssoLogin}>
                                                登录
                                            </Button>
                                        </div>
                                        <div className="login-secure-foot">
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                aria-hidden="true"
                                            >
                                                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                            </svg>
                                            <span>统一身份认证 · 全链路加密</span>
                                        </div>
                                    </div>
                                </div>

                            ):(
                                <div className="code-login-panel">
                                    <div className='login_back_btn' onClick={hideCodeLogin}>
                                       <a>返回手机登录</a>
                                    </div>
                                    <Tabs
                                        className='scan-login-tabs'
                                        activeKey={scanLoginType}
                                        onChange={(key) => setScanLoginType(key)}
                                    >
                                        <TabPane tab="钉钉扫码" key="dingtalk">
                                            <CodeLogin jumpUrl={redirectUrl}
                                                       iPV4={iPV4}
                                                       appid={appid}
                                                       networkIP={networkIP}
                                                       requestId={requestId}
                                                       isReturnSubordinate={isReturnSubordinate}
                                            />
                                        </TabPane>
                                        <TabPane tab="飞书扫码" key="feishu">
                                            <CodeLoginFs jumpUrl={redirectUrl}
                                                         iPV4={iPV4}
                                                         appid={appid}
                                                         networkIP={networkIP}
                                                         requestId={requestId}
                                            />
                                        </TabPane>
                                    </Tabs>
                                    {/*<div style={{position:'absolute',bottom:20,color:'#999999',fontSize:12,fontWeight:400,width:'85%',textAlign:'center'}}>*/}
                                    {/*    还没有账号？ 立即注册*/}
                                    {/*</div>*/}
                                </div>
                            )
                        }


                        {/*<div className='version'>版本号：V2021.1.1</div>*/}
                    </div>
                </div>

            </div>
            </div>
            <div className='ai-login-copyright'>
                <p>版权所有 © 2026 麦格凯科技。保留所有权利。</p>
                <p>Copyright © 2026 MAGKEY Technology. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Login;
